import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import norbrasil_logo from 'assets/img/account/norbrasil.png';
import sabesp_logo from 'assets/svg/SBS.svg';
import { gerarRelatorioPG } from 'utils/relatorios/relatorioPG';
import { gerarRelatorioNorbrasil } from 'utils/relatorios/relatorioNorbrasil';
import { gerarRelatorioFumaca } from 'utils/relatorios/relatorioFumaca';
import { gerarRelatorioCorante } from 'utils/relatorios/relatorioCorante';
import { gerarRelatorioCoranteSabesp } from 'utils/relatorios/relatorioCoranteSabesp';
import {
  Box, Flex, Text, Heading, Icon, Badge, Button, Spinner,
  SimpleGrid, Table, Thead, Tbody, Tr, Th, Td,
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton,
  ModalBody, ModalFooter, Textarea, Image, useDisclosure,
  useColorModeValue, useToast, IconButton, Divider,
  Input, InputGroup, InputLeftElement, Select, HStack, Tag, TagCloseButton,
  Tooltip, Progress, Switch, Checkbox, FormLabel,
  Tabs, TabList, Tab, TabPanels, TabPanel,
  AlertDialog, AlertDialogOverlay, AlertDialogContent,
  AlertDialogHeader, AlertDialogBody, AlertDialogFooter,
} from '@chakra-ui/react';
import {
  MdAdminPanelSettings, MdPeople, MdAssignment, MdCheckCircle, MdCancel,
  MdHourglassEmpty, MdTrendingUp, MdSearch, MdRefresh,
  MdVisibility, MdEdit, MdMap, MdLocationOn,
  MdAccessTime, MdCalendarToday, MdBusiness, MdSave,
  MdArrowUpward, MdArrowDownward, MdSupervisorAccount, MdPerson,
  MdAssignmentTurnedIn, MdFilterList, MdClose, MdDescription, MdPrint, MdCameraAlt, MdDownload, MdDelete,
  MdBugReport, MdExpandMore, MdExpandLess,
} from 'react-icons/md';
import {
  collection, onSnapshot, updateDoc, doc, getDoc, query, orderBy,
  deleteDoc, serverTimestamp, getDocs, limit,
} from 'firebase/firestore';
import Map, { Source, Layer, Popup } from 'react-map-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import Chart from 'react-apexcharts';
import { db, auth, storage } from '../../../firebase';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { MAPBOX_TOKEN } from 'utils/constants';
import Card from 'components/card/Card.js';
import TipoServicoField, { TIPOS_SERVICO } from 'components/fields/TipoServicoField';
import { geocodeAddress } from 'utils/geocode';
import TesteDeFumacaForm from 'components/forms/TesteDeFumacaForm';
import TesteCoranteForm from 'components/forms/TesteCoranteForm';
import { useAuth } from '../auth/AuthProvider';
import { remoteLog } from '../../../utils/remoteLog';
// MAPBOX_TOKEN now imported from utils/constants above

// ── Comprime imagem antes do upload (reduz ~5-15 MB → ~200-400 KB) ───────────────
function compressImage(file, maxPx = 1280, quality = 0.78) {
  return new Promise((resolve) => {
    if (!file || !file.type.startsWith('image/') ||
        file.type === 'image/heic' || file.type === 'image/heif') {
      resolve(file);
      return;
    }
    const img = new window.Image();
    const blobUrl = URL.createObjectURL(file);
    img.onload = () => {
      URL.revokeObjectURL(blobUrl);
      const scale = Math.min(1, maxPx / Math.max(img.width, img.height));
      const w = Math.round(img.width  * scale);
      const h = Math.round(img.height * scale);
      const canvas = document.createElement('canvas');
      canvas.width = w; canvas.height = h;
      canvas.getContext('2d').drawImage(img, 0, 0, w, h);
      canvas.toBlob((blob) => resolve(blob || file), 'image/jpeg', quality);
    };
    img.onerror = () => { URL.revokeObjectURL(blobUrl); resolve(file); };
    img.src = blobUrl;
  });
}

// ─── constants ────────────────────────────────────────────────────────────────
// MAPBOX_TOKEN is imported from utils/constants

const STATUS_COLORS = {
  rascunho:             'gray',
  enviada:              'blue',
  aguardando_validacao: 'orange',
  aprovada:             'green',
  reprovada:            'red',
};
const STATUS_LABELS = {
  rascunho:             'Rascunho',
  enviada:              'Enviada',
  aguardando_validacao: 'Ag. Validação',
  aprovada:             'Aprovada',
  reprovada:            'Reprovada',
};
const STATUS_OPTIONS = ['rascunho','enviada','aguardando_validacao','aprovada','reprovada'];

const CHECKLIST_PADRAO = [
  { id: 'epi',         label: 'EPI completo' },
  { id: 'sinalizacao', label: 'Sinalização da área' },
  { id: 'ferramentas', label: 'Ferramentas verificadas' },
  { id: 'foto_antes',  label: 'Foto antes do serviço' },
  { id: 'execucao',    label: 'Execução conforme padrão' },
  { id: 'limpeza',     label: 'Limpeza do local' },
  { id: 'foto_depois', label: 'Foto após serviço' },
];

const CONTRATOS = [
  { key: 'sjc',        numero: '11.529/25', cidade: 'São José dos Campos - SP', label: '11.529/25 — SJC'    },
  { key: 'sao_mateus', numero: '00262/25',      cidade: 'São Mateus',               label: '00262/25 — São Mateus' },
];

// ─── helpers ──────────────────────────────────────────────────────────────────
function fmt(ts) {
  if (!ts) return '--';
  const d = ts.toDate ? ts.toDate() : new Date(ts);
  return d.toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
}
function fmtDate(ts) {
  if (!ts) return '--';
  const d = ts.toDate ? ts.toDate() : new Date(ts);
  return d.toLocaleDateString('pt-BR');
}
function tsToDate(ts) {
  if (!ts) return null;
  return ts.toDate ? ts.toDate() : new Date(ts);
}
function dateKey(ts) {
  const d = tsToDate(ts);
  if (!d) return null;
  return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
}
function last30Days() {
  return Array.from({ length: 30 }, (_, i) => {
    const d = new Date();
    d.setDate(d.getDate() - (29 - i));
    return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
  });
}

// ─── main component ───────────────────────────────────────────────────────────
export default function PainelAdmin() {
  const { role } = useAuth() || {};
  const textColor   = useColorModeValue('navy.700', 'white');
  const subText     = useColorModeValue('gray.500', 'gray.400');
  const borderColor = useColorModeValue('gray.100', 'gray.600');
  const theadBg     = useColorModeValue('gray.50',  'navy.900');
  const rowHover    = useColorModeValue('blue.50',  'whiteAlpha.50');
  const cardBg      = useColorModeValue('white',    'navy.800');
  const obsBg       = useColorModeValue('gray.50',  'whiteAlpha.100');
  const inputBg     = useColorModeValue('white',    'navy.700');
  const mapBorder   = useColorModeValue('gray.200', 'gray.600');
  const chartMode   = useColorModeValue('light',    'dark');
  const logsTheadBg  = useColorModeValue('gray.50',  'gray.800');
  const toast       = useToast();

  // ─── data state ─────────────────────────────────────────────────────────────
  const [ordens,   setOrdens]   = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [nomesMap, setNomesMap] = useState({});
  const usersCache = useRef({});
  const mapRef      = useRef(null);

  // ─── filter state ───────────────────────────────────────────────────────────
  const [busca,         setBusca]         = useState('');
  const [filtroStatus,  setFiltroStatus]  = useState('all');
  const [filtroTecnico, setFiltroTecnico] = useState('all');
  const [dataInicio,    setDataInicio]    = useState('');
  const [dataFim,       setDataFim]       = useState('');

  // ─── sort / page ────────────────────────────────────────────────────────────
  const [sortField, setSortField] = useState('criadaEm');
  const [sortDir,   setSortDir]   = useState('desc');
  const [page,      setPage]      = useState(1);
  const PAGE_SIZE = 15;

  // ─── modal state ────────────────────────────────────────────────────────────
  const [selected,    setSelected]    = useState(null);
  const [nomeTecnico, setNomeTecnico] = useState('');
  const [editMode,    setEditMode]    = useState(false);
  // -- identificação
  const [editStatus,       setEditStatus]       = useState('');
  const [editNumOS,        setEditNumOS]         = useState('');
  const [editCliente,      setEditCliente]       = useState('');
  const [editTipoServico,  setEditTipoServico]   = useState('');
  const [editTipoOutros,   setEditTipoOutros]    = useState('');
  const [editHora,         setEditHora]          = useState('');
  const [editObs,          setEditObs]           = useState('');
  const [editAcaoSugestiva, setEditAcaoSugestiva] = useState('');
  // -- validação
  const [editComentarioVal, setEditComentarioVal] = useState('');
  // -- localização
  const [editLogradouro,   setEditLogradouro]    = useState('');
  const [editNumero,       setEditNumero]        = useState('');
  const [editComplemento,  setEditComplemento]   = useState('');
  const [editBairro,       setEditBairro]        = useState('');
  const [editCidade,       setEditCidade]        = useState('');
  const [editUf,           setEditUf]            = useState('');
  const [editCep,          setEditCep]           = useState('');
  const [editLat,          setEditLat]           = useState('');
  const [editLng,          setEditLng]           = useState('');
  // -- checklist
  const [editChecklist,    setEditChecklist]     = useState({});
  //
  const [saving,      setSaving]      = useState(false);
  const [fotoIdx,     setFotoIdx]     = useState(0);
  const [editFotos,   setEditFotos]   = useState([]);
  const editFotosInput    = useRef(null); // galeria (sem capture)
  const editFotosCameraRef = useRef(null); // câmera (capture)
  const [editDadosEspecificos, setEditDadosEspecificos] = useState(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  // company picker for relatório
  const { isOpen: isRelOpen, onOpen: onRelOpen, onClose: onRelClose } = useDisclosure();
  // confirmação de exclusão
  const { isOpen: isDeleteOpen, onOpen: onDeleteOpen, onClose: onDeleteClose } = useDisclosure();
  const [deleteTarget, setDeleteTarget] = useState(null); // OS a apagar
  const [deleting,     setDeleting]     = useState(false);
  const deleteRef = useRef();

  const pedirExclusao = (os) => { setDeleteTarget(os); onDeleteOpen(); };

  const confirmarExclusao = async () => {
    if (!deleteTarget) return;
    setDeleting(true);
    try {
      await deleteDoc(doc(db, 'ordens', deleteTarget.id));
      toast({ title: `OS ${deleteTarget.numeroOS || deleteTarget.id} excluída.`, status: 'success', duration: 3000, isClosable: true });
      onDeleteClose();
      setDeleteTarget(null);
    } catch (err) {
      console.error('Erro ao excluir OS:', err);
      toast({ title: 'Erro ao excluir', description: err.message, status: 'error', duration: 4000, isClosable: true });
    } finally {
      setDeleting(false);
    }
  };
  const [relatorioOS, setRelatorioOS] = useState(null);
  const [contratoSelecionado, setContratoSelecionado] = useState(CONTRATOS[0]);
  const [contratoNumeroInput, setContratoNumeroInput] = useState(CONTRATOS[0].numero);
  const [contratoCidadeInput, setContratoCidadeInput] = useState(CONTRATOS[0].cidade);

  // ─── app_logs state ──────────────────────────────────────────────────────────
  const [logsData,      setLogsData]      = useState([]);
  const [logsFilter,    setLogsFilter]    = useState('all');   // all | error | warn | info
  const [logsExpanded,  setLogsExpanded]  = useState(false);
  const [clearingLogs,  setClearingLogs]  = useState(false);

  // ─── map state ──────────────────────────────────────────────────────────────
  const [mapViewport, setMapViewport] = useState({ latitude:-23.5505, longitude:-46.6333, zoom:9 });
  const [mapPopup,    setMapPopup]    = useState(null);
  const [showMap,     setShowMap]     = useState(true);

  // ─── real-time subscription (app_logs) ──────────────────────────────────────
  useEffect(() => {
    if (!logsExpanded) return; // só carrega quando o card estiver aberto
    const q = query(collection(db, 'app_logs'), orderBy('ts', 'desc'), limit(200));
    const unsub = onSnapshot(q, (snap) => {
      setLogsData(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    }, (err) => { console.warn('app_logs snapshot error:', err.code); });
    return () => unsub();
  }, [logsExpanded]);

  const clearAllLogs = async () => {
    if (!window.confirm('Apagar todos os logs de sistema? Esta ação é permanente.')) return;
    setClearingLogs(true);
    try {
      const snap = await getDocs(query(collection(db, 'app_logs'), limit(500)));
      await Promise.all(snap.docs.map((d) => deleteDoc(d.ref)));
      setLogsData([]);
      toast({ title: 'Logs apagados.', status: 'success', duration: 2000, isClosable: true });
    } catch (err) {
      toast({ title: 'Erro ao apagar logs', description: err.message, status: 'error', duration: 4000, isClosable: true });
    } finally {
      setClearingLogs(false);
    }
  };

  // ─── real-time subscription ──────────────────────────────────────────────────
  useEffect(() => {
    const q = query(collection(db, 'ordens'), orderBy('criadaEm', 'desc'));
    const unsub = onSnapshot(q, async (snap) => {
      const docs = snap.docs.map((d) => {
        const data = d.data();
        // Fallback: promove lat/lng de dadosEspecificos para a raiz caso o salvamento antigo não os tenha gravado na raiz
        const lat = data.lat ?? data.dadosEspecificos?.lat ?? null;
        const lng = data.lng ?? data.dadosEspecificos?.lng ?? null;
        return { id: d.id, ...data, ...(lat != null ? { lat, lng } : {}) };
      });
      setOrdens(docs);
      setLoading(false);
      const uids = [...new Set(docs.map((o) => o.tecnicoUid).filter(Boolean))];
      const novos = {};
      await Promise.all(uids.map(async (uid) => {
        if (usersCache.current[uid]) { novos[uid] = usersCache.current[uid]; return; }
        try {
          const s = await getDoc(doc(db, 'users', uid));
          if (s.exists()) {
            const d = s.data();
            const n = d.firstName && d.lastName
              ? `${d.firstName} ${d.lastName}`
              : (d.displayName && !d.displayName.includes('@')) ? d.displayName : d.email || '';
            usersCache.current[uid] = n; novos[uid] = n;
          }
        } catch { novos[uid] = ''; }
      }));
      setNomesMap((prev) => ({ ...prev, ...novos }));
    }, () => setLoading(false));
    return unsub;
  }, []);

  // ─── KPIs ───────────────────────────────────────────────────────────────────
  const total         = ordens.length;
  const aguardando    = ordens.filter((o) => o.status === 'aguardando_validacao').length;
  const aprovadas     = ordens.filter((o) => o.status === 'aprovada').length;
  const reprovadas    = ordens.filter((o) => o.status === 'reprovada').length;
  const rascunhos     = ordens.filter((o) => o.status === 'rascunho').length;
  const taxaAprovacao = aprovadas + reprovadas > 0
    ? Math.round((aprovadas / (aprovadas + reprovadas)) * 100) : 0;
  const tecnicosAtivos = new Set(ordens.map((o) => o.tecnicoUid).filter(Boolean)).size;

  const STATS = [
    { label:'Total OS',        icon:MdAssignment,       color:'blue.400',   value:total,              filtro:'all'                 },
    { label:'Aguardando',      icon:MdHourglassEmpty,   color:'orange.400', value:aguardando,          filtro:'aguardando_validacao' },
    { label:'Aprovadas',       icon:MdCheckCircle,      color:'green.400',  value:aprovadas,           filtro:'aprovada'            },
    { label:'Reprovadas',      icon:MdCancel,           color:'red.400',    value:reprovadas,          filtro:'reprovada'           },
    { label:'Taxa Aprovação',  icon:MdTrendingUp,       color:'teal.400',   value:`${taxaAprovacao}%`, filtro:null                  },
    { label:'Técnicos Ativos', icon:MdSupervisorAccount,color:'purple.400', value:tecnicosAtivos,      filtro:null                  },
  ];

  // ─── filtered + sorted table ─────────────────────────────────────────────────
  const ordensFiltradas = useMemo(() => {
    let arr = [...ordens];
    if (filtroStatus !== 'all') arr = arr.filter((o) => o.status === filtroStatus);
    if (filtroTecnico !== 'all') arr = arr.filter((o) => o.tecnicoUid === filtroTecnico);
    if (dataInicio) {
      const di = new Date(dataInicio);
      arr = arr.filter((o) => { const d = tsToDate(o.criadaEm); return d && d >= di; });
    }
    if (dataFim) {
      const df = new Date(dataFim); df.setHours(23,59,59);
      arr = arr.filter((o) => { const d = tsToDate(o.criadaEm); return d && d <= df; });
    }
    if (busca.trim()) {
      const b = busca.toLowerCase();
      arr = arr.filter((o) => {
        const nome = (nomesMap[o.tecnicoUid] || o.tecnicoNome || '').toLowerCase();
        // campos raiz
        const endRaiz = [
          o.endereco, o.logradouro, o.bairro, o.cidade, o.numero
        ].filter(Boolean).join(' ').toLowerCase();
        // endereço dentro do dadosEspecificos (Corante: enderecoImovel, Fumaça: enderecoInspecionado)
        const endEsp = [
          o.dadosEspecificos?.enderecoImovel,
          o.dadosEspecificos?.enderecoInspecionado,
        ].filter(Boolean).join(' ').toLowerCase();
        return nome.includes(b)
          || (o.numeroOS    || '').toLowerCase().includes(b)
          || (o.tipoServico || '').toLowerCase().includes(b)
          || (o.cliente     || '').toLowerCase().includes(b)
          || endRaiz.includes(b)
          || endEsp.includes(b);
      });
    }
    arr.sort((a, b) => {
      let va = a[sortField], vb = b[sortField];
      if (va && va.toDate) va = va.toDate().getTime();
      if (vb && vb.toDate) vb = vb.toDate().getTime();
      if (va == null) return 1; if (vb == null) return -1;
      if (typeof va === 'string') va = va.toLowerCase();
      if (typeof vb === 'string') vb = vb.toLowerCase();
      const cmp = va < vb ? -1 : va > vb ? 1 : 0;
      return sortDir === 'asc' ? cmp : -cmp;
    });
    return arr;
  }, [ordens, filtroStatus, filtroTecnico, dataInicio, dataFim, busca, nomesMap, sortField, sortDir]);

  const totalPaginas = Math.ceil(ordensFiltradas.length / PAGE_SIZE);
  const ordensPage   = ordensFiltradas.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  // ─── KPIs de Relatório ──────────────────────────────────────────────────────
  const relatorioKpis = useMemo(() => {
    // Contagem por tipo de serviço
    const tipoCount = {};
    for (const o of ordensFiltradas) {
      const t = o.tipoServico || 'Sem tipo';
      tipoCount[t] = (tipoCount[t] || 0) + 1;
    }
    const tipoEntries = Object.entries(tipoCount).sort((a, b) => b[1] - a[1]);

    // Singularidades — Fumaça / Inspeção de Rede
    let singNormal = 0, singAnomalia = 0;
    const resultMap = {};
    for (const o of ordensFiltradas) {
      if (!['Teste de Fumaça', 'Inspeção de Rede'].includes(o.tipoServico)) continue;
      const sings = o.dadosEspecificos?.singularidades || [];
      for (const s of sings) {
        const res = Array.isArray(s.resultado) ? s.resultado : (s.resultado ? [s.resultado] : []);
        const isNormal = res.length === 0 || (res.length === 1 && res[0] === 'Normal');
        if (isNormal) singNormal++; else singAnomalia++;
        for (const r of res) {
          if (r && r !== 'Normal') resultMap[r] = (resultMap[r] || 0) + 1;
        }
      }
    }
    const topResultados = Object.entries(resultMap).sort((a, b) => b[1] - a[1]).slice(0, 4);

    // Esgotamento — Corante / Inspeção de Ramal
    // formaEsgotamento é um array de códigos (ex: ['02','07']) no dadosEspecificos raiz
    const COD_GROUP = {};
    const FORMAS_DEF = {
      'LIGADO':       ['', '01','02','03','04','05','06','07'],
      'FACTÍVEL':     ['21','22','23','24','25','26','27','28','29','33','34','35','36','37','38','42'],
      'POTENCIAL':    ['51','52','53','54','55'],
      'BOMBEAMENTO':  ['61','62','63','67','69'],
    };
    for (const [grp, codes] of Object.entries(FORMAS_DEF))
      for (const c of codes) COD_GROUP[c] = grp;

    const esgoCount = { 'LIGADO': 0, 'FACTÍVEL': 0, 'POTENCIAL': 0, 'BOMBEAMENTO': 0 };
    for (const o of ordensFiltradas) {
      if (o.tipoServico !== 'Testes de Corante/Inspeção Ramal') continue;
      const codes = o.dadosEspecificos?.formaEsgotamento || [];
      for (const cod of codes) {
        const grp = COD_GROUP[cod];
        if (grp) esgoCount[grp]++;
      }
    }
    const esgoEntries = Object.entries(esgoCount).filter(([, v]) => v > 0);
    const esgoTotal   = esgoEntries.reduce((s, [, v]) => s + v, 0);

    return { tipoEntries, singNormal, singAnomalia, topResultados, esgoEntries, esgoTotal };
  }, [ordensFiltradas]);

  function toggleSort(field) {
    if (sortField === field) setSortDir((d) => d === 'asc' ? 'desc' : 'asc');
    else { setSortField(field); setSortDir('desc'); }
    setPage(1);
  }
  function SortIcon({ field }) {
    if (sortField !== field) return null;
    return <Icon as={sortDir==='asc'?MdArrowUpward:MdArrowDownward} ml="4px" boxSize="12px"/>;
  }

  const techOptions = useMemo(() => {
    const s = [...new Set(ordens.map((o) => o.tecnicoUid).filter(Boolean))];
    return s.map((uid) => ({ uid, nome: nomesMap[uid] || uid }));
  }, [ordens, nomesMap]);

  function limparFiltros() {
    setBusca(''); setFiltroStatus('all'); setFiltroTecnico('all');
    setDataInicio(''); setDataFim(''); setPage(1);
  }
  const filtrosAtivos = busca || filtroStatus !== 'all' || filtroTecnico !== 'all' || dataInicio || dataFim;

  // ─── chart data ──────────────────────────────────────────────────────────────
  // Filtra fatias com valor 0 — ApexCharts crasha ao clicar na legenda de valor 0
  const _donutRaw = [
    { label:'Aprovadas',  color:'#00C49A', val: aprovadas },
    { label:'Reprovadas', color:'#e53e3e', val: reprovadas },
    { label:'Aguardando', color:'#DD6B20', val: aguardando },
    { label:'Rascunho',   color:'#718096', val: rascunhos },
    { label:'Enviadas',   color:'#3182ce', val: ordens.filter((o) => o.status === 'enviada').length },
  ].filter((d) => d.val > 0);
  const donutSeries  = _donutRaw.map((d) => d.val);
  const donutOptions = {
    chart: { type:'donut', fontFamily:'DM Sans, sans-serif', background:'transparent' },
    labels: _donutRaw.map((d) => d.label),
    colors: _donutRaw.map((d) => d.color),
    legend: { position:'bottom', fontSize:'11px' },
    plotOptions: { pie: { donut: { size:'65%',
      labels: { show:true,
        name:  { show:true, fontSize:'11px', color:'#A0AEC0', offsetY:-4 },
        value: { show:true, fontSize:'22px', fontWeight:'800', offsetY:4,
          formatter: () => String(total) },
        total:{ show:true, label:'Total', fontSize:'11px', color:'#A0AEC0', formatter:()=>String(total) },
      },
    }}},
    dataLabels: { enabled:false },
    stroke: { width:0 },
    theme: { mode: chartMode },
  };

  const techBarData = useMemo(() => {
    const map = {};
    ordens.forEach((o) => {
      const nome = nomesMap[o.tecnicoUid] || o.tecnicoNome || 'Desconhecido';
      map[nome] = (map[nome]||0)+1;
    });
    const sorted = Object.entries(map).sort((a,b)=>b[1]-a[1]).slice(0,8);
    return { cats: sorted.map(([n])=>n), vals: sorted.map(([,v])=>v) };
  }, [ordens, nomesMap]);

  const barOptions = {
    chart: { type:'bar', toolbar:{show:false}, fontFamily:'DM Sans, sans-serif', background:'transparent' },
    plotOptions: { bar:{ horizontal:true, borderRadius:4, distributed:true } },
    colors: ['#4299E1','#48BB78','#ED8936','#9F7AEA','#FC8181','#63B3ED','#68D391','#F6AD55'],
    dataLabels: { enabled:true, formatter:(v)=>`${v}`, style:{fontSize:'11px'} },
    xaxis: { categories:techBarData.cats, labels:{style:{fontSize:'11px'}} },
    yaxis: { labels:{style:{fontSize:'11px'}, maxWidth:120} },
    legend: { show:false },
    theme: { mode:chartMode },
    grid: { borderColor: chartMode==='dark'?'#2d3748':'#f0f0f0' },
  };
  const barSeries = [{ name:'OS', data:techBarData.vals }];

  const lineData = useMemo(() => {
    const days = last30Days();
    const map = {}; days.forEach((d) => (map[d]=0));
    ordens.forEach((o) => { const k=dateKey(o.criadaEm); if(k && map[k]!==undefined) map[k]++; });
    return { cats:days.map((d)=>d.slice(5)), vals:days.map((d)=>map[d]) };
  }, [ordens]);

  const lineOptions = {
    chart: { type:'area', toolbar:{show:false}, fontFamily:'DM Sans, sans-serif', animations:{enabled:true,speed:600}, background:'transparent' },
    stroke: { curve:'smooth', width:2 },
    fill: { type:'gradient', gradient:{shadeIntensity:1,inverseColors:false,opacityFrom:.4,opacityTo:0} },
    colors: ['#4299E1'],
    xaxis: { categories:lineData.cats, tickAmount:6, labels:{rotate:-30,style:{fontSize:'10px'}} },
    yaxis: { min:0, forceNiceScale:true, labels:{style:{fontSize:'11px'}} },
    dataLabels: { enabled:false },
    tooltip: { y:{ formatter:(v)=>`${v} OS` } },
    grid: { borderColor: chartMode==='dark'?'#2d3748':'#f0f0f0', strokeDashArray:4 },
    theme: { mode:chartMode },
  };
  const lineSeries = [{ name:'OS criadas', data:lineData.vals }];

  // ─── GeoJSON for map ─────────────────────────────────────────────────────────
  const geojson = useMemo(() => ({
    type:'FeatureCollection',
    features: ordens.filter((o)=>o.lat && o.lng).map((o)=>({
      type:'Feature',
      geometry: { type:'Point', coordinates:[o.lng, o.lat] },
      properties: {
        id: o.id, status:o.status,
        numeroOS: o.numeroOS || o.id.slice(-6),
        tecnico: nomesMap[o.tecnicoUid] || o.tecnicoNome || '',
        tipo: o.tipoServico || '',
        cor: o.status==='aprovada'?'#48BB78'
           : o.status==='reprovada'?'#FC8181'
           : o.status==='aguardando_validacao'?'#ED8936':'#63B3ED',
      },
    })),
  }), [ordens, nomesMap]);
  const hasGeo = geojson.features.length > 0;

  const circleLayer = {
    id:'os-circles', type:'circle',
    paint: {
      'circle-radius':['interpolate',['linear'],['zoom'],6,5,14,13],
      'circle-color':['get','cor'],
      'circle-stroke-width':2,
      'circle-stroke-color':'#fff',
      'circle-opacity':0.95,
    },
  };

  const fitMapBounds = useCallback(() => {
    if (!mapRef.current || geojson.features.length === 0) return;
    const coords = geojson.features.map(f => f.geometry.coordinates);
    if (coords.length === 1) {
      mapRef.current.flyTo({ center: coords[0], zoom: 14, duration: 1000 });
      return;
    }
    const lngs = coords.map(c => c[0]);
    const lats = coords.map(c => c[1]);
    mapRef.current.fitBounds(
      [[Math.min(...lngs), Math.min(...lats)], [Math.max(...lngs), Math.max(...lats)]],
      { padding: 80, duration: 1000, maxZoom: 15 }
    );
  }, [geojson]);

  // ─── modal open / save ───────────────────────────────────────────────────────
  const abrirOS = useCallback(async (os) => {
    setSelected(os); setFotoIdx(0); setEditMode(false);
    setEditFotos((os.fotos||[]).map(f=>({url:f.url, preview:f.url, legenda:f.legenda||'', file:null})));
    setEditDadosEspecificos(os.dadosEspecificos || null);
    // identificação
    setEditStatus(os.status||'rascunho');
    setEditNumOS(os.numeroOS||'');
    setEditCliente(os.cliente||'');
    // Detect if stored tipoServico is a custom text (not in the canonical list)
    // This handles both old data ('Outros' + tipoOutros) and new data (custom text stored directly).
    const storedTipo = os.tipoServico || '';
    const isCustom = storedTipo && !TIPOS_SERVICO.includes(storedTipo);
    setEditTipoServico(isCustom ? 'Outros' : storedTipo);
    setEditTipoOutros(isCustom ? storedTipo : (os.tipoOutros || ''));
    setEditHora(os.hora||'');
    setEditObs(os.observacoes||'');
    setEditAcaoSugestiva(os.acaoSugestiva||'');
    setEditComentarioVal(os.comentarioValidacao||'');
    // localização
    setEditLogradouro(os.logradouro||'');
    setEditNumero(os.numero||'');
    setEditComplemento(os.complemento||'');
    setEditBairro(os.bairro||'');
    setEditCidade(os.cidade||'');
    setEditUf(os.uf||'');
    setEditCep(os.cep||'');
    setEditLat(os.lat!=null ? String(os.lat) : '');
    setEditLng(os.lng!=null ? String(os.lng) : '');
    // checklist
    setEditChecklist(os.checklist || {});
    const cached = nomesMap[os.tecnicoUid] || usersCache.current[os.tecnicoUid];
    if (cached) { setNomeTecnico(cached); }
    else if (os.tecnicoUid) {
      try {
        const snap = await getDoc(doc(db,'users',os.tecnicoUid));
        if (snap.exists()) {
          const d = snap.data();
          const n = d.firstName && d.lastName ? `${d.firstName} ${d.lastName}` : d.displayName||'';
          usersCache.current[os.tecnicoUid]=n;
          setNomesMap((p)=>({...p,[os.tecnicoUid]:n})); setNomeTecnico(n);
        } else setNomeTecnico(os.tecnicoNome||'');
      } catch { setNomeTecnico(os.tecnicoNome||''); }
    } else setNomeTecnico(os.tecnicoNome||'');
    onOpen();
  }, [nomesMap, onOpen]);

  // ── upload helper: serializa fotos aninhadas em dadosEspecificos ──────────
  const uploadFotoEsp = async (uid, id, foto) => {
    if (!foto || !foto.file) return foto ? { url: foto.url, legenda: foto.legenda || '' } : null;
    const compressed = await compressImage(foto.file);
    const contentType = compressed.type || 'image/jpeg';
    const nome = `esp_${Date.now()}.jpg`;
    const storRef = ref(storage, `ordens/${uid}/${id}/${nome}`);
    await uploadBytes(storRef, compressed, { contentType });
    return { url: await getDownloadURL(storRef), legenda: foto.legenda || '' };
  };
  const uploadDadosEsp = async (uid, id, dados) => {
    if (!dados) return dados;
    const d = { ...dados };
    if (Array.isArray(d.singularidades)) {
      d.singularidades = await Promise.all(d.singularidades.map(async s => ({
        ...s,
        fotoInicio: await uploadFotoEsp(uid, id, s.fotoInicio),
        fotoFim:    await uploadFotoEsp(uid, id, s.fotoFim),
      })));
    }
    if (Array.isArray(d.ocorrencias)) {
      d.ocorrencias = await Promise.all(d.ocorrencias.map(async oc => ({
        ...oc,
        fotos: Array.isArray(oc.fotos)
          ? await Promise.all(oc.fotos.map(f => uploadFotoEsp(uid, id, f)))
          : oc.fotos,
      })));
    }
    if (Array.isArray(d.fotos)) {
      d.fotos = await Promise.all(d.fotos.map(f => uploadFotoEsp(uid, id, f)));
    }
    if (d.fotoEnderecoInspecionado) {
      d.fotoEnderecoInspecionado = await uploadFotoEsp(uid, id, d.fotoEnderecoInspecionado);
    }
    if (d.fotoGoogleMaps) {
      d.fotoGoogleMaps = await uploadFotoEsp(uid, id, d.fotoGoogleMaps);
    }
    if (d.assinaturaCliente && d.assinaturaCliente.startsWith('data:')) {
      const res  = await fetch(d.assinaturaCliente);
      const blob = await res.blob();
      const sRef = ref(storage, `ordens/${uid}/${id}/assinatura_cliente.png`);
      await uploadBytes(sRef, blob);
      d.assinaturaCliente = await getDownloadURL(sRef);
    }
    return d;
  };

  const salvarEdicao = async () => {
    if (!selected) return;
    setSaving(true);
    try {
      const uploaderUid = auth.currentUser?.uid;
      if (!uploaderUid) {
        throw new Error('Sessão expirada. Faça login novamente para enviar fotos.');
      }
      // Garante token fresco antes de qualquer upload — evita expirar no meio
      await auth.currentUser.getIdToken(true);
      remoteLog('info', 'save_os_start', 'Início de salvamento de OS',
        { osId: selected.id, nFotos: editFotos.length,
          nFotosEsp: Array.isArray(editDadosEspecificos?.fotos) ? editDadosEspecificos.fotos.length : 0,
          temAssinatura: !!editDadosEspecificos?.assinaturaCliente });
      // ── upload de fotos novas e serializar todas ──────────────────────
      const fotosFinais = [];
      for (const f of editFotos) {
        if (f.url) { fotosFinais.push({ url: f.url, legenda: f.legenda }); continue; }
        const compressed = await compressImage(f.file);
        const contentType = compressed.type || 'image/jpeg';
        const storRef = ref(storage, `ordens/${uploaderUid}/${selected.id}/${Date.now()}.jpg`);
        await uploadBytes(storRef, compressed, { contentType });
        fotosFinais.push({ url: await getDownloadURL(storRef), legenda: f.legenda });
      }
      // ── upload de dados específicos (fumaça / corante) ────────────────
      const dadosEspSalvos = editDadosEspecificos
        ? await uploadDadosEsp(uploaderUid, selected.id, editDadosEspecificos)
        : null;
      const latNum = editLat.trim() ? parseFloat(editLat) : null;
      const lngNum = editLng.trim() ? parseFloat(editLng) : null;
      const enderecoCompleto = [editLogradouro, editNumero, editComplemento, editBairro, editCidade, editUf]
        .filter(Boolean).join(', ');
      // Auto-geocoding: se não digitou lat/lng mas tem endereço, busca automaticamente
      let resolvedLat = (!isNaN(latNum) && latNum !== null) ? latNum : null;
      let resolvedLng = (!isNaN(lngNum) && lngNum !== null) ? lngNum : null;
      if ((resolvedLat == null || resolvedLng == null) && editLogradouro) {
        const coords = await geocodeAddress({
          logradouro: editLogradouro, numero: editNumero,
          bairro: editBairro, cidade: editCidade, uf: editUf, cep: editCep,
        });
        if (coords) { resolvedLat = coords.lat; resolvedLng = coords.lng; }
      }
      await updateDoc(doc(db,'ordens',selected.id), {
        status:           editStatus,
        numeroOS:         editNumOS,
        cliente:          editCliente,
        tipoServico:      editTipoServico === 'Outros' ? editTipoOutros.trim() : editTipoServico,
        tipoOutros:       editTipoServico === 'Outros' ? editTipoOutros.trim() : null,
        hora:             editHora,
        observacoes:      editObs,
        acaoSugestiva:    editAcaoSugestiva || null,
        comentarioValidacao: editComentarioVal || null,
        logradouro:       editLogradouro,
        numero:           editNumero,
        complemento:      editComplemento,
        bairro:           editBairro,
        cidade:           editCidade,
        uf:               editUf,
        cep:              editCep,
        endereco:         enderecoCompleto,
        lat:              resolvedLat,
        lng:              resolvedLng,
        checklist:        editChecklist,
        fotos:            fotosFinais,
        dadosEspecificos: dadosEspSalvos,
        atualizadaEm:     serverTimestamp(),
      });
      toast({ title:'OS atualizada com sucesso!', status:'success', duration:2500 });
      remoteLog('info', 'save_os_success', 'OS salva com sucesso', { osId: selected.id });
      setEditMode(false); onClose();
    } catch(e) {
      remoteLog('error', 'save_os_failed', `Falha ao salvar OS: ${e?.code || e?.message}`,
        { osId: selected?.id, code: e?.code, message: e?.message });
      toast({ title:'Erro ao salvar', description:e.message, status:'error' });
    } finally { setSaving(false); }
  };

  // ── download de foto (contorna CORS do Firebase Storage) ─────────────────
  const downloadFoto = async (src, idx) => {
    if (!src) return;
    const nome = `foto_${idx + 1}.jpg`;
    // blob:/data: — foto local ainda não enviada, download direto sem fetch
    if (src.startsWith('blob:') || src.startsWith('data:')) {
      const a = document.createElement('a');
      a.href = src; a.download = nome;
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      return;
    }
    // URL remota do Firebase Storage — requer CORS no bucket
    try {
      const resp = await fetch(src, { mode: 'cors', credentials: 'omit' });
      if (!resp.ok) throw new Error('fetch failed');
      const blob   = await resp.blob();
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl; a.download = nome;
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      setTimeout(() => URL.revokeObjectURL(blobUrl), 3000);
    } catch {
      window.open(src, '_blank');
    }
  };

  // ── adicionar fotos na OS (principal) ────────────────────────────────────
  const handleAddFotosOS = (e) => {
    const novas = Array.from(e.target.files).map(f => ({
      file: f, preview: URL.createObjectURL(f), url: null, legenda: '',
    }));
    setEditFotos(prev => [...prev, ...novas]);
    e.target.value = '';
  };

  const abrirSeletorRelatorio = useCallback((os) => {
    setRelatorioOS(os);
    onRelOpen();
  }, [onRelOpen]);

  const imprimirRelatorio = useCallback((os, empresa, contrato) => {
    const tecnicoNome = nomesMap[os.tecnicoUid] || os.tecnicoNome || '--';
    const opts        = { STATUS_LABELS, CHECKLIST_PADRAO, contrato: contrato || CONTRATOS[0] };
    const logoUrl     = empresa === 'norbrasil' ? norbrasil_logo : empresa === 'sabesp' ? sabesp_logo : window.location.origin + '/logo.png';
    const tipo        = (os.tipoServico || '').toLowerCase();

    let html;
    if (tipo.includes('fumaça') || tipo.includes('fumaca') || tipo.includes('inspeção de rede')) {
      html = gerarRelatorioFumaca(os, tecnicoNome, logoUrl, opts, empresa);
    } else if (tipo.includes('corante') || tipo.includes('ramal')) {
      html = empresa === 'sabesp'
        ? gerarRelatorioCoranteSabesp(os, tecnicoNome, logoUrl, opts, empresa)
        : gerarRelatorioCorante(os, tecnicoNome, logoUrl, opts, empresa);
    } else {
      // fallback: relatório genérico
      html = empresa === 'norbrasil'
        ? gerarRelatorioNorbrasil(os, tecnicoNome, norbrasil_logo, opts)
        : gerarRelatorioPG(os, tecnicoNome, window.location.origin + '/logo.png', opts);
    }

    const win = window.open('', '_blank', 'width=900,height=980,scrollbars=yes');
    if (win) { win.document.write(html); win.document.close(); }
  }, [nomesMap]);

  // ── (legacy inline kept for reference — replaced by generators) ───────────
  const _imprimirRelatorio_LEGACY = useCallback((os, empresa) => {
    const logoUrl = window.location.origin + '/logo.png';
    const EMPRESAS = {
      pg: {
        nome:     'PG SOLUÇÕES INTELIGENTES',
        subtitle: 'Sistema de Gestão de Ordens de Serviço',
        cor:      '#2b6cb0',
        corLight: '#bee3f8',
      },
      norbrasil: {
        nome:     'NORBRASIL',
        subtitle: 'Sistema de Gestão de Ordens de Serviço',
        cor:      '#276749',
        corLight: '#c6f6d5',
      },
    };
    const emp = EMPRESAS[empresa] || EMPRESAS.pg;
    const nome = nomesMap[os.tecnicoUid] || os.tecnicoNome || '--';
    const checklistHtml = CHECKLIST_PADRAO.map(({ id, label }) =>
      `<tr><td style="padding:4px 8px;font-size:16px;">${os.checklist?.[id] ? '✅' : '✗'}</td><td style="padding:4px 8px;${os.checklist?.[id]?'':'text-decoration:line-through;color:#a0aec0;'}">${label}</td></tr>`
    ).join('');
    const fotosHtml = (os.fotos||[]).map((f) =>
      `<div style="display:inline-block;margin:6px;vertical-align:top;text-align:center;">
        <img src="${f.url}" style="width:200px;height:150px;object-fit:cover;border-radius:8px;border:1px solid #e2e8f0;"/>
        ${f.legenda ? `<div style="font-size:11px;color:#718096;margin-top:4px;">${f.legenda}</div>` : ''}
      </div>`
    ).join('');
    const badgeColors = { aprovada:'#c6f6d5;color:#276749', reprovada:'#fed7d7;color:#9b2c2c',
      aguardando_validacao:'#feebc8;color:#7b341e', rascunho:'#e2e8f0;color:#4a5568', enviada:'#bee3f8;color:#2c5282' };
    const bc = badgeColors[os.status] || '#e2e8f0;color:#4a5568';
    const html = `<!DOCTYPE html><html lang="pt-BR"><head><meta charset="UTF-8"/>
      <title>Relatório OS ${os.numeroOS||os.id.slice(-6)} — ${emp.nome}</title>
      <style>
        *{box-sizing:border-box;} body{font-family:Arial,sans-serif;margin:0;padding:24px;font-size:13px;color:#1a202c;}
        h1{font-size:20px;margin:0 0 4px;} h2{font-size:13px;font-weight:700;margin:16px 0 8px;color:${emp.cor};border-bottom:2px solid ${emp.corLight};padding-bottom:4px;text-transform:uppercase;letter-spacing:.04em;}
        .header{display:flex;align-items:flex-start;justify-content:space-between;margin-bottom:16px;border-bottom:3px solid ${emp.cor};padding-bottom:12px;}
        .badge{display:inline-block;padding:3px 10px;border-radius:20px;font-size:11px;font-weight:700;background:${bc.split(';')[0]};}
        .grid{display:grid;grid-template-columns:1fr 1fr;gap:8px 24px;}
        .field{margin-bottom:6px;} .field .lbl{font-size:10px;text-transform:uppercase;font-weight:700;color:#718096;} .field p{margin:2px 0 0;}
        table{border-collapse:collapse;width:100%;} td{vertical-align:middle;}
        .val-box{padding:10px;border-radius:8px;margin-top:8px;}
        .ap-box{background:#f0fff4;border:1px solid #9ae6b4;} .rp-box{background:#fff5f5;border:1px solid #feb2b2;}
        @media print{button{display:none!important;} body{padding:12px;}}
      </style></head><body>
      <div class="header">
        <div style="display:flex;align-items:center;gap:14px;">
          <img src="${logoUrl}" style="height:56px;object-fit:contain;" alt="Logo"/>
          <div>
            <div style="font-size:11px;color:#718096;font-weight:700;text-transform:uppercase;letter-spacing:.05em;">${emp.nome}</div>
            <div style="font-size:10px;color:#a0aec0;">${emp.subtitle}</div>
            <h1 style="color:${emp.cor};">Ordem de Serviço #${os.numeroOS||os.id.slice(-6)}</h1>
            <span class="badge">${STATUS_LABELS[os.status]||os.status}</span>
          </div>
        </div>
        <div style="text-align:right;font-size:11px;color:#718096;">
          <div>Criada em: <strong>${fmt(os.criadaEm)}</strong></div>
          <div>Atualizada: <strong>${fmt(os.atualizadaEm)}</strong></div>
          ${os.validadaEm ? `<div>Validada: <strong>${fmt(os.validadaEm)}</strong></div>` : ''}
        </div>
      </div>
      <h2>Identificação</h2>
      <div class="grid">
        <div class="field"><div class="lbl">Nº OS</div><p>${os.numeroOS||'--'}</p></div>
        <div class="field"><div class="lbl">Cliente</div><p>${os.cliente||'--'}</p></div>
        <div class="field"><div class="lbl">Tipo de Serviço</div><p>${os.tipoServico||'--'}${os.tipoOutros?' ('+os.tipoOutros+')':''}</p></div>
        <div class="field"><div class="lbl">Hora</div><p>${os.hora||'--'}</p></div>
      </div>
      <h2>Técnico Responsável</h2>
      <div class="field"><div class="lbl">Nome</div><p>${nome}</p></div>
      <h2>Localização</h2>
      <div class="grid">
        <div class="field"><div class="lbl">Logradouro</div><p>${os.logradouro||'--'}</p></div>
        <div class="field"><div class="lbl">Número</div><p>${os.numero||'--'}</p></div>
        <div class="field"><div class="lbl">Complemento</div><p>${os.complemento||'--'}</p></div>
        <div class="field"><div class="lbl">Bairro</div><p>${os.bairro||'--'}</p></div>
        <div class="field"><div class="lbl">Cidade</div><p>${os.cidade||'--'}</p></div>
        <div class="field"><div class="lbl">UF</div><p>${os.uf||'--'}</p></div>
        <div class="field"><div class="lbl">CEP</div><p>${os.cep||'--'}</p></div>
        ${os.lat && os.lng ? `<div class="field" style="grid-column:1/-1"><div class="lbl">Coordenadas GPS</div><p>Lat: ${Number(os.lat).toFixed(6)} / Lng: ${Number(os.lng).toFixed(6)}</p></div>` : ''}
      </div>
      <h2>Checklist</h2>
      <table><tbody>${checklistHtml}</tbody></table>
      ${os.observacoes ? `<h2>Nota de Conclusão</h2><p style="white-space:pre-wrap;">${os.observacoes}</p>` : ''}
      ${os.acaoSugestiva ? `<h2>Ação Sugestiva</h2><p style="white-space:pre-wrap;">${os.acaoSugestiva}</p>` : ''}
      ${os.validadorNome ? `<h2>Validação</h2>
        <div class="val-box ${os.status==='aprovada'?'ap-box':'rp-box'}">
          <strong>${os.status==='aprovada'?'✅ Aprovada':'❌ Reprovada'}</strong> por ${os.validadorNome}${os.validadaEm?' em '+fmt(os.validadaEm):''}
          ${os.comentarioValidacao?'<br/><em>'+os.comentarioValidacao+'</em>':''}
        </div>` : ''}
      ${fotosHtml ? `<h2>Fotos (${(os.fotos||[]).length})</h2><div>${fotosHtml}</div>` : '<h2>Fotos</h2><p style="color:#a0aec0;">Nenhuma foto anexada.</p>'}
      <div style="text-align:center;margin-top:24px;">
        <button onclick="window.print()" style="padding:10px 28px;background:${emp.cor};color:#fff;border:none;border-radius:8px;cursor:pointer;font-size:14px;font-weight:700;">🖨️ Imprimir / Salvar PDF</button>
      </div>
    </body></html>`;
    const win2 = window.open('', '_blank', 'width=860,height=950,scrollbars=yes');
    if (win2) { win2.document.write(html); win2.document.close(); }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ─────────────────────────────────────────────────────────────────────────────
  // Render
  // ─────────────────────────────────────────────────────────────────────────────
  // detecção de tipo de formulário específico (recalculado a cada render)
  const _activeTipo  = editTipoServico || selected?.tipoServico || '';
  const isFumacaAtiva  = ['Teste de Fumaça', 'Inspeção de Rede'].includes(_activeTipo);
  const isCoranteAtivo = _activeTipo === 'Testes de Corante/Inspeção Ramal';
  const hasDadosEsp    = isFumacaAtiva || isCoranteAtivo;

  return (
    <Box pb="40px">
      {/* ── Header ─────────────────────────────────────────────────────────── */}
      <Card bg={cardBg} p={{ base:'16px', md:'20px' }} mb="20px">
        <Flex align="center" justify="space-between" wrap="wrap" gap="12px">
          <Flex align="center" gap="14px">
            <Flex bg="brand.500" borderRadius="16px" w="52px" h="52px"
              align="center" justify="center" flexShrink={0}>
              <Icon as={MdAdminPanelSettings} boxSize="28px" color="white" />
            </Flex>
            <Box>
              <Heading size="md" color={textColor}>Painel Administrativo</Heading>
              <Text fontSize="sm" color={subText} mt="2px">
                Análise, gestão e relatórios.
              </Text>
            </Box>
          </Flex>
          {loading && <Spinner size="sm" color="brand.500" />}
        </Flex>
      </Card>

      {/* ── KPI Cards ──────────────────────────────────────────────────────── */}
      <SimpleGrid columns={{ base:2, md:3, xl:6 }} gap="12px" mb="20px">
        {STATS.map(({ label, icon, color, value, filtro }) => {
          const ativo = filtroStatus === filtro && filtro !== null;
          return (
            <Card key={label} bg={cardBg} p={{ base:'10px 8px', md:'16px' }}
              border="2px solid" borderColor={ativo ? color : 'transparent'}
              cursor={filtro ? 'pointer' : 'default'}
              onClick={() => { if (filtro) { setFiltroStatus(filtro); setPage(1); } }}
              _hover={filtro ? { borderColor:color, transform:'translateY(-2px)', transition:'all .2s' } : {}}
              transition="all .2s">
              <Flex direction={{ base:'column', md:'row' }} align={{ base:'center', md:'flex-start' }} gap={{ base:'4px', md:'10px' }}>
                <Icon as={icon} boxSize={{ base:'26px', md:'26px' }} color={color} flexShrink={0} />
                <Box textAlign={{ base:'center', md:'left' }}>
                  <Text fontSize={{ base:'20px', md:'24px' }} fontWeight="800" color={color} lineHeight="1">
                    {value}
                  </Text>
                  <Text fontSize={{ base:'9px', md:'10px' }} color={subText} mt="2px" fontWeight="600">{label}</Text>
                </Box>
              </Flex>
              {label==='Taxa Aprovação' && (
                <Progress mt="8px" value={taxaAprovacao} size="xs" colorScheme="teal" borderRadius="full" />
              )}
            </Card>
          );
        })}
      </SimpleGrid>

      {/* ── Charts Row ─────────────────────────────────────────────────────── */}
      <SimpleGrid columns={{ base:1, lg:3 }} gap="16px" mb="20px">
        <Card bg={cardBg} p={{ base:'16px', md:'20px' }}>
          <Heading size="xs" color={textColor} mb="12px">Distribuição por Status</Heading>
          {total > 0
            ? <Chart options={donutOptions} series={donutSeries} type="donut" height={220} />
            : <Flex h="220px" align="center" justify="center"><Text color={subText} fontSize="sm">Sem dados ainda</Text></Flex>
          }
        </Card>

        <Card bg={cardBg} p={{ base:'16px', md:'20px' }}>
          <Heading size="xs" color={textColor} mb="12px">Top Técnicos por OS</Heading>
          {techBarData.vals.length > 0
            ? <Chart options={barOptions} series={barSeries} type="bar" height={220} />
            : <Flex h="220px" align="center" justify="center"><Text color={subText} fontSize="sm">Sem dados ainda</Text></Flex>
          }
        </Card>

        <Card bg={cardBg} p={{ base:'16px', md:'20px' }}>
          <Heading size="xs" color={textColor} mb="12px">OS Criadas — Últimos 30 dias</Heading>
          <Chart options={lineOptions} series={lineSeries} type="area" height={220} />
        </Card>
      </SimpleGrid>

      {/* ── KPIs de Relatório ──────────────────────────────────────────────── */}
      {ordensFiltradas.length > 0 && (
        <SimpleGrid columns={{ base:1, md:3 }} gap="16px" mb="16px">

          {/* ── Tipos de Serviço ── */}
          <Card bg={cardBg} p={{ base:'14px', md:'16px' }}>
            <Text fontSize="11px" fontWeight="700" color={subText} mb="2px"
              textTransform="uppercase" letterSpacing="0.5px">Tipos de Serviço</Text>
            <Text fontSize="10px" color={subText} mb="10px">OS por modalidade</Text>
            {relatorioKpis.tipoEntries.length > 0 ? (
              <Chart
                type="bar"
                height={Math.min(relatorioKpis.tipoEntries.length, 5) * 38 + 24}
                options={{
                  chart: { type:'bar', toolbar:{ show:false }, background:'transparent', fontFamily:'DM Sans, sans-serif' },
                  plotOptions: { bar: { horizontal:true, borderRadius:4, dataLabels:{ position:'center' } } },
                  dataLabels: { enabled:true, style:{ fontSize:'11px', fontWeight:'700', colors:['#fff'] } },
                  xaxis: {
                    categories: relatorioKpis.tipoEntries.slice(0,5).map(([t]) => t),
                    labels:{ show:false }, axisBorder:{ show:false }, axisTicks:{ show:false },
                  },
                  yaxis: { labels:{ style:{ fontSize:'11px' }, maxWidth: 180 } },
                  grid: { show:false },
                  theme: { mode: chartMode },
                  colors: ['#4299E1'],
                  tooltip: { y:{ formatter:(v) => `${v} OS` } },
                }}
                series={[{ name:'OS', data: relatorioKpis.tipoEntries.slice(0,5).map(([,c]) => c) }]}
              />
            ) : (
              <Flex h="100px" align="center" justify="center">
                <Text fontSize="12px" color={subText}>Sem dados</Text>
              </Flex>
            )}
          </Card>

          {/* ── Singularidades ── */}
          <Card bg={cardBg} p={{ base:'14px', md:'16px' }}>
            <Text fontSize="11px" fontWeight="700" color={subText} mb="2px"
              textTransform="uppercase" letterSpacing="0.5px">Singularidades — Fumaça / Rede</Text>
            <Text fontSize="10px" color={subText} mb="6px">Normal vs Anomalia</Text>
            {relatorioKpis.singNormal + relatorioKpis.singAnomalia === 0 ? (
              <Flex h="160px" align="center" justify="center">
                <Text fontSize="12px" color={subText}>Sem dados de Fumaça</Text>
              </Flex>
            ) : (
              <>
                <Chart
                  type="donut"
                  height={160}
                  options={{
                    chart: { type:'donut', background:'transparent', fontFamily:'DM Sans, sans-serif' },
                    labels: ['Normais', 'Anomalias'],
                    colors: ['#48BB78', '#ED8936'],
                    legend: { position:'bottom', fontSize:'11px' },
                    plotOptions: { pie: { donut: { size:'65%', labels: { show:true,
                      name:  { show:true, fontSize:'11px', color:'#A0AEC0', offsetY:-4 },
                      value: { show:true, fontSize:'22px', fontWeight:'800', offsetY:4,
                        formatter: () => String(relatorioKpis.singNormal + relatorioKpis.singAnomalia) },
                      total: { show:true, label:'Total',
                        fontSize:'11px', color:'#A0AEC0',
                        formatter: () => String(relatorioKpis.singNormal + relatorioKpis.singAnomalia) },
                    }}}},
                    dataLabels: { enabled:false },
                    stroke: { width:0 },
                    theme: { mode: chartMode },
                  }}
                  series={[relatorioKpis.singNormal, relatorioKpis.singAnomalia]}
                />
                {relatorioKpis.topResultados.length > 0 && (
                  <Box mt="8px">
                    <Text fontSize="10px" color={subText} mb="6px" fontWeight="700"
                      textTransform="uppercase" letterSpacing="0.5px">Top resultados</Text>
                    {relatorioKpis.topResultados.map(([res, cnt]) => {
                      const pct = relatorioKpis.singAnomalia > 0
                        ? Math.round((cnt / relatorioKpis.singAnomalia) * 100) : 0;
                      return (
                        <Box key={res} mb="6px">
                          <Flex justify="space-between" mb="2px">
                            <Text fontSize="11px" color={textColor} flex="1" mr="6px"
                              overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap">{res}</Text>
                            <Text fontSize="11px" color={subText} fontWeight="600">{cnt}</Text>
                          </Flex>
                          <Progress value={pct} size="xs" colorScheme="orange" borderRadius="full" />
                        </Box>
                      );
                    })}
                  </Box>
                )}
              </>
            )}
          </Card>

          {/* ── Esgotamento ── */}
          <Card bg={cardBg} p={{ base:'14px', md:'16px' }}>
            <Text fontSize="11px" fontWeight="700" color={subText} mb="2px"
              textTransform="uppercase" letterSpacing="0.5px">Esgotamento — Corante / Ramal</Text>
            <Text fontSize="10px" color={subText} mb="6px">Situação dos ramais inspecionados</Text>
            {relatorioKpis.esgoTotal === 0 ? (
              <Flex h="160px" align="center" justify="center">
                <Text fontSize="12px" color={subText}>Sem dados de Corante</Text>
              </Flex>
            ) : (
              <>
                <Chart
                  type="donut"
                  height={160}
                  options={{
                    chart: { type:'donut', background:'transparent', fontFamily:'DM Sans, sans-serif' },
                    labels: relatorioKpis.esgoEntries.map(([g]) => g),
                    colors: relatorioKpis.esgoEntries.map(([g]) =>
                      ({ 'LIGADO':'#48BB78', 'FACTÍVEL':'#4299E1', 'POTENCIAL':'#ED8936', 'BOMBEAMENTO':'#9F7AEA' }[g] || '#718096')),
                    legend: { position:'bottom', fontSize:'11px' },
                    plotOptions: { pie: { donut: { size:'65%', labels: { show:true,
                      name:  { show:true, fontSize:'11px', color:'#A0AEC0', offsetY:-4 },
                      value: { show:true, fontSize:'22px', fontWeight:'800', offsetY:4,
                        formatter: () => String(relatorioKpis.esgoTotal) },
                      total: { show:true, label:'Total',
                        fontSize:'11px', color:'#A0AEC0',
                        formatter: () => String(relatorioKpis.esgoTotal) },
                    }}}},
                    dataLabels: { enabled:false },
                    stroke: { width:0 },
                    theme: { mode: chartMode },
                  }}
                  series={relatorioKpis.esgoEntries.map(([,v]) => v)}
                />
                <Box mt="8px">
                  {relatorioKpis.esgoEntries.map(([grupo, count]) => {
                    const pct = Math.round((count / relatorioKpis.esgoTotal) * 100);
                    const colorMap = { 'LIGADO':'green', 'FACTÍVEL':'blue', 'POTENCIAL':'orange', 'BOMBEAMENTO':'purple' };
                    return (
                      <Flex key={grupo} align="center" mb="5px" gap="8px">
                        <Text fontSize="11px" color={textColor} fontWeight="600" minW="100px">{grupo}</Text>
                        <Progress flex="1" value={pct} size="xs" colorScheme={colorMap[grupo]||'gray'} borderRadius="full" />
                        <Text fontSize="11px" color={subText} minW="30px" textAlign="right">{count}</Text>
                      </Flex>
                    );
                  })}
                </Box>
              </>
            )}
          </Card>

        </SimpleGrid>
      )}

      {/* ── Filtros ────────────────────────────────────────────────────────── */}
      <Card bg={cardBg} p={{ base:'14px', md:'20px' }} mb="16px">
        <Flex align="center" gap="8px" mb="12px">
          <Icon as={MdFilterList} boxSize="20px" color="brand.500" />
          <Text fontWeight="700" fontSize="sm" color={textColor}>Filtros</Text>
          {filtrosAtivos && (
            <Tag size="sm" colorScheme="red" borderRadius="full" cursor="pointer" onClick={limparFiltros}>
              Limpar <TagCloseButton />
            </Tag>
          )}
        </Flex>
        <SimpleGrid columns={{ base:1, sm:2, md:3, xl:5 }} gap="10px">
          <InputGroup size="sm">
            <InputLeftElement pointerEvents="none"><Icon as={MdSearch} color="gray.400"/></InputLeftElement>
            <Input pl="8" placeholder="Buscar OS, técnico, endereço..." bg={inputBg} borderRadius="8px"
              fontSize={{ base: '16px', md: 'sm' }} h={{ base: '42px', md: 'auto' }}
              value={busca} onChange={(e)=>{ setBusca(e.target.value); setPage(1); }} />
          </InputGroup>

          <Select size="sm" bg={inputBg} borderRadius="8px"
            fontSize={{ base: '16px', md: 'sm' }} h={{ base: '42px', md: 'auto' }}
            value={filtroStatus} onChange={(e)=>{ setFiltroStatus(e.target.value); setPage(1); }}>
            <option value="all">Todos os status</option>
            {STATUS_OPTIONS.map((s)=>(<option key={s} value={s}>{STATUS_LABELS[s]}</option>))}
          </Select>

          <Select size="sm" bg={inputBg} borderRadius="8px"
            fontSize={{ base: '16px', md: 'sm' }} h={{ base: '42px', md: 'auto' }}
            value={filtroTecnico} onChange={(e)=>{ setFiltroTecnico(e.target.value); setPage(1); }}>
            <option value="all">Todos os técnicos</option>
            {techOptions.map(({ uid, nome })=>(<option key={uid} value={uid}>{nome}</option>))}
          </Select>

          <InputGroup size="sm">
            <InputLeftElement pointerEvents="none">
              <Icon as={MdCalendarToday} color="gray.400" boxSize="13px"/>
            </InputLeftElement>
            <Input type="date" pl="8" bg={inputBg} borderRadius="8px"
              fontSize={{ base: '16px', md: 'sm' }} h={{ base: '42px', md: 'auto' }}
              value={dataInicio} onChange={(e)=>{ setDataInicio(e.target.value); setPage(1); }} />
          </InputGroup>

          <InputGroup size="sm">
            <InputLeftElement pointerEvents="none">
              <Icon as={MdCalendarToday} color="gray.400" boxSize="13px"/>
            </InputLeftElement>
            <Input type="date" pl="8" bg={inputBg} borderRadius="8px"
              fontSize={{ base: '16px', md: 'sm' }} h={{ base: '42px', md: 'auto' }}
              value={dataFim} onChange={(e)=>{ setDataFim(e.target.value); setPage(1); }} />
          </InputGroup>
        </SimpleGrid>

        <Flex mt="10px" align="center" justify="space-between" wrap="wrap" gap="8px">
          <Text fontSize="xs" color={subText}>
            {ordensFiltradas.length} OS encontradas{filtrosAtivos && ` (de ${total} total)`}
          </Text>
          <HStack spacing="6px" flexWrap="wrap">
            {filtroStatus !== 'all' && (
              <Tag size="sm" colorScheme={STATUS_COLORS[filtroStatus]||'gray'} borderRadius="full">
                {STATUS_LABELS[filtroStatus]} <TagCloseButton onClick={()=>setFiltroStatus('all')}/>
              </Tag>
            )}
            {filtroTecnico !== 'all' && (
              <Tag size="sm" colorScheme="blue" borderRadius="full">
                {techOptions.find(t=>t.uid===filtroTecnico)?.nome||filtroTecnico}
                <TagCloseButton onClick={()=>setFiltroTecnico('all')}/>
              </Tag>
            )}
          </HStack>
        </Flex>
      </Card>

      {/* ── Table ──────────────────────────────────────────────────────────── */}
      <Card bg={cardBg} p={{ base:'14px', md:'20px' }} mb="20px">
        <Flex justify="space-between" align="center" mb="14px" wrap="wrap" gap="8px">
          <Heading size="sm" color={textColor}>Ordens de Serviço</Heading>
          <Text fontSize="xs" color={subText}>Pág. {page}/{Math.max(1,totalPaginas)}</Text>
        </Flex>

        {loading ? (
          <Flex justify="center" py="12"><Spinner size="lg" color="brand.500"/></Flex>
        ) : ordensFiltradas.length === 0 ? (
          <Flex direction="column" align="center" py="12" gap="3">
            <Icon as={MdAssignment} boxSize="48px" color="gray.300"/>
            <Text color={subText} fontSize="sm">Nenhuma OS encontrada</Text>
          </Flex>
        ) : (
          <>
            <Box overflowX="auto">
              <Table variant="simple" size="sm">
                <Thead bg={theadBg}>
                  <Tr>
                    {[
                      { label:'Nº OS',     field:'numeroOS'     },
                      { label:'Técnico',   field:'tecnicoNome'  },
                      { label:'Tipo',      field:'tipoServico',  hide:true },
                      { label:'Endereço',  field:'endereco',     hide:true },
                      { label:'Data',      field:'criadaEm'     },
                      { label:'Status',    field:'status',       hide:true },
                    ].map(({ label, field, hide }) => (
                      <Th key={field} borderColor={borderColor} color={subText}
                        cursor="pointer" userSelect="none"
                        display={hide ? { base:'none', md:'table-cell' } : undefined}
                        onClick={()=>toggleSort(field)}
                        _hover={{ color:'brand.500' }} transition="color .15s">
                        <Flex align="center">{label}<SortIcon field={field}/></Flex>
                      </Th>
                    ))}
                    <Th borderColor={borderColor}/>
                  </Tr>
                </Thead>
                <Tbody>
                  {ordensPage.map((os) => (
                    <Tr key={os.id} _hover={{ bg:rowHover }} transition="background .15s">
                      <Td borderColor={borderColor} fontWeight="600" fontSize="13px" color={textColor}>
                        {os.numeroOS || <Text as="span" color={subText} fontSize="11px">{os.id.slice(-6)}</Text>}
                      </Td>
                      <Td borderColor={borderColor} fontSize="13px">
                        {nomesMap[os.tecnicoUid] || os.tecnicoNome || '--'}
                      </Td>
                      <Td borderColor={borderColor} fontSize="12px"
                        display={{ base:'none', md:'table-cell' }} maxW="160px"
                        overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap">
                        {os.tipoServico||'--'}
                      </Td>
                      <Td borderColor={borderColor} fontSize="12px"
                        display={{ base:'none', md:'table-cell' }} maxW="220px"
                        overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap"
                        title={os.endereco || os.logradouro || os.dadosEspecificos?.enderecoImovel || os.dadosEspecificos?.enderecoInspecionado || ''}>
                        {os.endereco || os.logradouro
                          ? [os.logradouro || os.endereco, os.numero].filter(Boolean).join(', ')
                          : os.dadosEspecificos?.enderecoImovel
                          || os.dadosEspecificos?.enderecoInspecionado
                          || '--'}
                      </Td>

                      <Td borderColor={borderColor} fontSize="11px" color={subText}>
                        {fmtDate(os.criadaEm)}
                      </Td>
                      <Td borderColor={borderColor} display={{ base:'none', md:'table-cell' }}>
                        <Badge colorScheme={STATUS_COLORS[os.status]||'gray'}
                          borderRadius="full" px="2" fontSize="10px">
                          {STATUS_LABELS[os.status]||os.status}
                        </Badge>
                      </Td>
                      <Td borderColor={borderColor} isNumeric>
                        <HStack spacing="1px" justify="flex-end">
                          <Tooltip label={os.lat && os.lng ? `GPS: ${Number(os.lat).toFixed(5)}, ${Number(os.lng).toFixed(5)}` : 'Sem coordenadas GPS'} placement="top">
                            <span>
                              <Icon as={MdLocationOn}
                                boxSize="14px"
                                color={os.lat && os.lng ? 'green.400' : 'gray.300'}
                                cursor="default"
                              />
                            </span>
                          </Tooltip>
                          <Tooltip label="Ver / Editar" placement="top">
                            <IconButton icon={<Icon as={MdEdit}/>} size="xs" variant="ghost"
                              aria-label="Abrir OS" colorScheme="brand"
                              onClick={()=>abrirOS(os)} />
                          </Tooltip>
                          <Tooltip label="Relatório" placement="top">
                            <IconButton icon={<Icon as={MdDescription}/>} size="xs" variant="ghost"
                              aria-label="Relatório" colorScheme="green"
                              onClick={()=>abrirSeletorRelatorio(os)} />
                          </Tooltip>
                          <Tooltip label="Apagar OS" placement="top">
                            <IconButton icon={<Icon as={MdDelete}/>} size="xs" variant="ghost"
                              aria-label="Apagar OS" colorScheme="red"
                              onClick={()=>pedirExclusao(os)} />
                          </Tooltip>
                        </HStack>
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </Box>

            {totalPaginas > 1 && (
              <Flex justify="center" align="center" gap="6px" mt="14px" wrap="wrap">
                <Button size="xs" isDisabled={page===1} onClick={()=>setPage(1)}>«</Button>
                <Button size="xs" isDisabled={page===1} onClick={()=>setPage(p=>p-1)}>‹</Button>
                {Array.from({ length: Math.min(7,totalPaginas) }, (_,i) => {
                  const p = Math.min(Math.max(page-3,1)+i, totalPaginas);
                  return (
                    <Button key={p} size="xs"
                      colorScheme={p===page?'brand':undefined}
                      variant={p===page?'solid':'outline'}
                      onClick={()=>setPage(p)}>{p}</Button>
                  );
                })}
                <Button size="xs" isDisabled={page===totalPaginas} onClick={()=>setPage(p=>p+1)}>›</Button>
                <Button size="xs" isDisabled={page===totalPaginas} onClick={()=>setPage(totalPaginas)}>»</Button>
              </Flex>
            )}
          </>
        )}
      </Card>

      {/* ── Mapa de Calor ──────────────────────────────────────────────────── */}
      <Card bg={cardBg} p={{ base:'14px', md:'20px' }} mb="20px" overflow="hidden">
        <Flex justify="space-between" align="center" mb="14px" wrap="wrap" gap="8px">
          <Flex align="center" gap="8px">
            <Icon as={MdMap} boxSize="20px" color="brand.500"/>
            <Heading size="sm" color={textColor}>Mapa de Calor — Concentração de Atendimentos</Heading>
          </Flex>
          <HStack spacing="10px" flexWrap="wrap">
            {[{c:'green.400',l:'Aprovada'},{c:'orange.400',l:'Aguardando'},{c:'red.400',l:'Reprovada'},{c:'blue.300',l:'Outros'}]
              .map(({c,l})=>(
                <Flex key={l} align="center" gap="4px">
                  <Box w="8px" h="8px" borderRadius="full" bg={c}/>
                  <Text fontSize="10px" color={subText}>{l}</Text>
                </Flex>
              ))}
            {showMap && hasGeo && (
              <Button size="xs" variant="ghost" colorScheme="blue"
                onClick={fitMapBounds}>
                Centralizar
              </Button>
            )}
            <Button size="xs" variant="ghost" colorScheme="gray"
              onClick={()=>setShowMap(v=>!v)}>
              {showMap?'Ocultar':'Mostrar'}
            </Button>
          </HStack>
        </Flex>

        {!hasGeo && (
          <Flex direction="column" align="center" py="8" gap="2">
            <Icon as={MdLocationOn} boxSize="40px" color="gray.300"/>
            <Text color={subText} fontSize="sm">Nenhuma OS com coordenadas GPS disponível</Text>
          </Flex>
        )}

        {hasGeo && ordens.filter(o => !o.lat || !o.lng).length > 0 && (
          <Flex align="center" gap="2" mb="8px" px="2" py="6px"
            bg="orange.50" borderRadius="8px" borderLeft="3px solid" borderColor="orange.300"
            _dark={{ bg:'orange.900', borderColor:'orange.400' }}>
            <Icon as={MdLocationOn} color="orange.400" boxSize="16px" flexShrink={0}/>
            <Text fontSize="12px" color="orange.700" _dark={{ color:'orange.200' }}>
              <b>{ordens.filter(o => !o.lat || !o.lng).length} OS</b> sem coordenadas GPS — use o botão de edição ✏️ para adicionar manualmente.
            </Text>
          </Flex>
        )}

        {showMap && hasGeo && (
          <Box borderRadius="12px" overflow="hidden" h={{ base:'300px', md:'440px' }}
            border="1px solid" borderColor={mapBorder}>
            <Map
              ref={mapRef}
              {...mapViewport}
              onMove={(e)=>setMapViewport(e.viewState)}
              onLoad={fitMapBounds}
              mapStyle="mapbox://styles/mapbox/satellite-streets-v12"
              mapboxAccessToken={MAPBOX_TOKEN}
              interactiveLayerIds={['os-circles']}
              onClick={(e)=>{
                const feat = e.features?.[0];
                if (feat) setMapPopup({ ...feat.properties, lat:e.lngLat.lat, lng:e.lngLat.lng });
              }}
              cursor="pointer"
              style={{ width:'100%', height:'100%' }}
            >
              <Source id="os-source" type="geojson" data={geojson}>
                <Layer {...circleLayer}/>
              </Source>
              {mapPopup && (
                <Popup latitude={mapPopup.lat} longitude={mapPopup.lng}
                  onClose={()=>setMapPopup(null)} closeButton closeOnClick={false} anchor="bottom">
                  <Box p="6px" minW="140px">
                    <Text fontWeight="700" fontSize="13px">OS {mapPopup.numeroOS}</Text>
                    <Text fontSize="12px" color="gray.600">{mapPopup.tecnico||'--'}</Text>
                    <Text fontSize="12px" color="gray.600">{mapPopup.tipo||'--'}</Text>
                    <Badge mt="4px" colorScheme={STATUS_COLORS[mapPopup.status]||'gray'} fontSize="10px">
                      {STATUS_LABELS[mapPopup.status]||mapPopup.status}
                    </Badge>
                    <Button mt="6px" size="xs" colorScheme="blue" w="100%"
                      onClick={()=>{
                        const os = ordens.find(o=>o.id===mapPopup.id);
                        if (os) { abrirOS(os); setMapPopup(null); }
                      }}>Abrir OS</Button>
                  </Box>
                </Popup>
              )}
            </Map>
          </Box>
        )}
        {showMap && hasGeo && (
          <Text textAlign="right" fontSize="10px" color={subText} mt="6px">
            {geojson.features.length} OS plotadas no mapa
          </Text>
        )}
      </Card>

      {/* ── Modal: Ver / Editar OS ─────────────────────────────────────────── */}
      <Modal isOpen={isOpen} onClose={()=>{ onClose(); setEditMode(false); }}
        size={{ base: 'full', md: 'xl' }} scrollBehavior="inside" motionPreset="slideInBottom">
        <ModalOverlay backdropFilter="blur(4px)"/>
        <ModalContent m={{ base: 0, md: 'auto' }} borderRadius={{ base: 0, md: '16px' }}>
          <ModalHeader pb="2">
            <Box>
              <Text fontSize="md" fontWeight="800" color={textColor}>
                OS {selected?.numeroOS || selected?.id?.slice(-6)}
              </Text>
              <Text fontSize="sm" color={subText}>
                {nomeTecnico||selected?.tecnicoNome} &mdash; {selected?.tipoServico||'--'}
              </Text>
            </Box>
          </ModalHeader>
          <ModalCloseButton/>

          <ModalBody pb="4">
            {selected && (
              <Tabs variant="soft-rounded" colorScheme="brand" size="sm">
                <TabList mb="14px" flexWrap="wrap" gap="4px">
                  <Tab><Icon as={MdAssignment} mr="5px"/>Detalhes</Tab>
                  {hasDadosEsp && <Tab>🔬 Dados Técnicos</Tab>}
                </TabList>

                <TabPanels>
                  {/* Tab 1: Detalhes */}
                  <TabPanel px="0">
                    <SimpleGrid columns={2} gap="10px" mb="10px">
                      <Box>
                        <Text fontSize="10px" color={subText} fontWeight="600" textTransform="uppercase">Status</Text>
                        <Select size="sm" mt="1" value={editStatus}
                          fontSize={{ base:'16px', md:'sm' }} h={{ base:'44px', md:'auto' }}
                          onChange={(e)=>setEditStatus(e.target.value)}>
                          {STATUS_OPTIONS.map(s=>(<option key={s} value={s}>{STATUS_LABELS[s]}</option>))}
                        </Select>
                      </Box>
                      <Box>
                        <Text fontSize="10px" color={subText} fontWeight="600" textTransform="uppercase">Nº OS</Text>
                        <Input size="sm" mt="1" value={editNumOS}
                          fontSize={{ base:'16px', md:'sm' }} h={{ base:'44px', md:'auto' }}
                          onChange={(e)=>setEditNumOS(e.target.value)}/>
                      </Box>
                      <Box>
                        <Text fontSize="10px" color={subText} fontWeight="600" textTransform="uppercase">Cliente</Text>
                        <Input size="sm" mt="1" value={editCliente}
                          fontSize={{ base:'16px', md:'sm' }} h={{ base:'44px', md:'auto' }}
                          onChange={(e)=>setEditCliente(e.target.value)}/>
                      </Box>
                      <Box>
                        <Text fontSize="10px" color={subText} fontWeight="600" textTransform="uppercase">Hora</Text>
                        <Input size="sm" mt="1" type="time" value={editHora}
                          fontSize={{ base:'16px', md:'sm' }} h={{ base:'44px', md:'auto' }}
                          sx={{ colorScheme: 'auto' }}
                          onChange={(e)=>setEditHora(e.target.value)}/>
                      </Box>
                      <Box gridColumn="1 / -1">
                        <Text fontSize="10px" color={subText} fontWeight="600" textTransform="uppercase">Tipo de Serviço</Text>
                        <Box mt="1">
                          <TipoServicoField
                            value={editTipoServico}
                            onChange={setEditTipoServico}
                            outrosValue={editTipoOutros}
                            onOutrosChange={setEditTipoOutros}
                            size="sm"
                            h={{ base:'44px', md:'40px' }}
                          />
                        </Box>
                      </Box>
                      <Box>
                        <Text fontSize="10px" color={subText} fontWeight="600" textTransform="uppercase">Técnico</Text>
                        <Text fontSize="sm" mt="1">{nomeTecnico||selected.tecnicoNome||'--'}</Text>
                      </Box>
                      <Box>
                        <Text fontSize="10px" color={subText} fontWeight="600" textTransform="uppercase">Criada em</Text>
                        <Text fontSize="sm" mt="1">{fmt(selected.criadaEm)}</Text>
                      </Box>
                      <Box>
                        <Text fontSize="10px" color={subText} fontWeight="600" textTransform="uppercase">Atualizada em</Text>
                        <Text fontSize="sm" mt="1">{fmt(selected.atualizadaEm)}</Text>
                      </Box>
                    </SimpleGrid>

                    <Divider my="10px"/>

                    {/* Validação */}
                    {selected.validadorNome && (
                      <Box bg={selected.status==='aprovada'?'green.50':'red.50'}
                        borderRadius="8px" p="10px" mb="10px"
                        border="1px solid" borderColor={selected.status==='aprovada'?'green.200':'red.200'}>
                        <Text fontSize="xs" fontWeight="700"
                          color={selected.status==='aprovada'?'green.700':'red.700'}>
                          {selected.status==='aprovada'?'✅ Aprovada':'❌ Reprovada'} por {selected.validadorNome}
                          {selected.validadaEm && ` em ${fmt(selected.validadaEm)}`}
                        </Text>
                            <Box mt="6px">
                              <Text fontSize="10px" color="gray.500" fontWeight="600" mb="2px">Comentário da Validação</Text>
                              <Textarea size="xs" rows={2} value={editComentarioVal}
                                fontSize={{ base:'16px', md:'xs' }}
                                onChange={(e)=>setEditComentarioVal(e.target.value)}/>
                            </Box>
                          </Box>
                        )}

                        <Box>
                          <Text fontSize="10px" color={subText} fontWeight="600" textTransform="uppercase" mb="6px">
                            Nota de Conclusão
                          </Text>
                          <Textarea size="sm" rows={4} value={editObs}
                            fontSize={{ base:'16px', md:'sm' }}
                            onChange={(e)=>setEditObs(e.target.value)} placeholder="Resumo final da conclusão do atendimento..."/>
                        </Box>

                        <Box mt="10px">
                          <Text fontSize="10px" color={subText} fontWeight="600" textTransform="uppercase" mb="6px">
                            Ação Sugestiva
                          </Text>
                          <Textarea size="sm" rows={3} value={editAcaoSugestiva}
                            fontSize={{ base:'16px', md:'sm' }}
                            onChange={(e)=>setEditAcaoSugestiva(e.target.value)} placeholder="Ação sugerida para tratativa ou continuidade..."/>
                        </Box>

                        <Divider my="10px"/>

                        {/* Fotos da OS */}
                        <Box>
                          <Text fontSize="10px" color={subText} fontWeight="600" textTransform="uppercase" mb="8px">
                            Fotos ({editFotos.length})
                          </Text>

                          {/* inputs hidden: câmera + galeria */}
                          <input ref={editFotosCameraRef} type="file" accept="image/*" capture="environment"
                            style={{ display:'none' }} onChange={handleAddFotosOS} />
                          <input ref={editFotosInput} type="file"
                            accept="image/jpeg,image/png,image/gif,image/webp,image/heic,image/heif"
                            multiple style={{ display:'none' }} onChange={handleAddFotosOS} />

                          {editFotos.length === 0 && (
                            <Text fontSize="sm" color={subText} textAlign="center" py="3">
                              Nenhuma foto anexada.
                            </Text>
                          )}

                          <SimpleGrid columns={{ base:1, sm:2 }} gap="10px" mb="10px">
                            {editFotos.map((f, i) => (
                              <Box key={i} borderRadius="10px" overflow="hidden"
                                border="1px solid" borderColor={borderColor}>
                                <Box position="relative">
                                  <Image
                                    src={f.preview || f.url}
                                    w="100%" h="120px" objectFit="cover"
                                  />
                                  {/* Botões sobre a imagem */}
                                  <Flex position="absolute" top="6px" right="6px" gap="4px">
                                    <Tooltip label="Download" placement="top">
                                      <IconButton
                                        icon={<Icon as={MdDownload}/>}
                                        size="sm" colorScheme="blue" borderRadius="full"
                                        aria-label="Download foto"
                                        onClick={() => downloadFoto(f.preview || f.url, i)}
                                      />
                                    </Tooltip>
                                    <Tooltip label="Remover" placement="top">
                                      <IconButton
                                        icon={<Icon as={MdClose}/>}
                                        size="sm" colorScheme="red" borderRadius="full"
                                        aria-label="Remover foto"
                                        onClick={() => setEditFotos(prev => prev.filter((_,j)=>j!==i))}
                                      />
                                    </Tooltip>
                                  </Flex>
                                </Box>
                                <Box px="8px" py="6px">
                                  <Text fontSize="10px" color={subText} mb="3px">Foto {i+1}</Text>
                                  <Input
                                    size="xs" borderRadius="6px"
                                    placeholder="Legenda..."
                                    fontSize={{ base:'16px', md:'xs' }}
                                    value={f.legenda || ''}
                                    onChange={(e) => setEditFotos(prev =>
                                      prev.map((p,j) => j===i ? {...p, legenda:e.target.value} : p)
                                    )}
                                  />
                                </Box>
                              </Box>
                            ))}
                          </SimpleGrid>

                          {/* Botão adicionar */}
                          <SimpleGrid columns={2} gap="8px">
                            <Button size="sm" h={{ base:'44px', md:'36px' }}
                              leftIcon={<Icon as={MdCameraAlt}/>}
                              variant="outline" colorScheme="brand" borderRadius="10px"
                              onClick={() => editFotosCameraRef.current?.click()}>
                              Câmera
                            </Button>
                            <Button size="sm" h={{ base:'44px', md:'36px' }}
                              leftIcon={<Icon as={MdCameraAlt}/>}
                              variant="outline" colorScheme="brand" borderRadius="10px"
                              onClick={() => editFotosInput.current?.click()}>
                              Galeria
                            </Button>
                          </SimpleGrid>
                        </Box>
                  </TabPanel>

                  {/* Tab 2: Dados Técnicos (Teste de Fumaça / Corante) */}
                  {hasDadosEsp && (
                    <TabPanel px="0" pb="0">
                      {isFumacaAtiva
                        ? <TesteDeFumacaForm
                            value={editDadosEspecificos}
                            onChange={setEditDadosEspecificos}
                            showAdminUploads
                          />
                        : <TesteCoranteForm
                            value={editDadosEspecificos}
                            onChange={setEditDadosEspecificos}
                          />
                      }
                    </TabPanel>
                  )}
                </TabPanels>
              </Tabs>
            )}
          </ModalBody>

          <ModalFooter borderTop="1px solid" borderColor={borderColor} pt="12px">
            <Flex w="100%" justify="space-between" align="center">
              <Button size="sm" h={{ base:'48px', md:'32px' }} variant="ghost" colorScheme="green"
                leftIcon={<Icon as={MdDescription}/>}
                onClick={()=>{ onClose(); abrirSeletorRelatorio(selected); }}>
                Relatório
              </Button>
              <Flex gap="8px">
                <Button size="sm" h={{ base:'48px', md:'32px' }} variant="outline"
                  onClick={()=>{ onClose(); }}>
                  Fechar
                </Button>
                <Button size="sm" h={{ base:'48px', md:'32px' }} colorScheme="brand"
                  leftIcon={<Icon as={MdSave}/>}
                  isLoading={saving} onClick={salvarEdicao}>
                  Salvar
                </Button>
              </Flex>
            </Flex>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* ── Logs de Sistema ──────────────────────────────────────────────── */}
      {role === 'admin' || role === 'supervisor' ? (
        <Card mt="20px" px="20px" py="16px">
          {/* ── cabeçalho do card ── */}
          <Flex align="center" justify="space-between" mb={logsExpanded ? '16px' : '0'}>
            <Flex align="center" gap="10px">
              <Icon as={MdBugReport} boxSize="22px" color="purple.500" />
              <Heading size="sm" color="secondaryGray.900">Logs de Sistema</Heading>
              {logsExpanded && logsData.length > 0 && (
                <Badge colorScheme="purple" borderRadius="full">{logsData.length}</Badge>
              )}
            </Flex>
            <HStack spacing="8px">
              {logsExpanded && role === 'admin' && (
                <Button size="xs" colorScheme="red" variant="outline"
                  isLoading={clearingLogs} onClick={clearAllLogs}>
                  Limpar todos
                </Button>
              )}
              <IconButton
                size="sm" variant="ghost"
                aria-label={logsExpanded ? 'Recolher' : 'Expandir'}
                icon={<Icon as={logsExpanded ? MdExpandLess : MdExpandMore} />}
                onClick={() => setLogsExpanded((v) => !v)}
              />
            </HStack>
          </Flex>

          {logsExpanded && (
            <>
              {/* ── filtro de nível ── */}
              <HStack mb="12px" spacing="6px" flexWrap="wrap">
                {[['all','Todos','gray'],['error','Erro','red'],['warn','Aviso','orange'],['info','Info','blue']].map(([val,lbl,clr]) => (
                  <Button key={val} size="xs"
                    colorScheme={logsFilter === val ? clr : 'gray'}
                    variant={logsFilter === val ? 'solid' : 'outline'}
                    onClick={() => setLogsFilter(val)}>
                    {lbl}
                  </Button>
                ))}
                <Text fontSize="xs" color="gray.400" ml="4px">
                  {logsFilter === 'all' ? logsData.length : logsData.filter(l => l.level === logsFilter).length} entradas
                </Text>
              </HStack>

              {/* ── tabela ── */}
              <Box overflowX="auto" maxH="420px" overflowY="auto"
                borderWidth="1px" borderRadius="md">
                <Table size="sm" variant="simple">
                  <Thead position="sticky" top={0} zIndex={1}
                    bg={logsTheadBg}>
                    <Tr>
                      <Th whiteSpace="nowrap">Hora</Th>
                      <Th>Nível</Th>
                      <Th>Evento</Th>
                      <Th>Usuário</Th>
                      <Th>Dispositivo</Th>
                      <Th>Mensagem</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {logsData
                      .filter(l => logsFilter === 'all' || l.level === logsFilter)
                      .map((log) => {
                        const ts = log.ts?.toDate ? log.ts.toDate() : null;
                        const hora = ts
                          ? ts.toLocaleString('pt-BR', { dateStyle:'short', timeStyle:'short' })
                          : '—';
                        const lvlColor = log.level === 'error' ? 'red'
                          : log.level === 'warn' ? 'orange' : 'blue';
                        return (
                          <Tr key={log.id}>
                            <Td whiteSpace="nowrap" fontSize="xs">{hora}</Td>
                            <Td>
                              <Badge colorScheme={lvlColor} borderRadius="full" fontSize="2xs">
                                {log.level === 'error' ? 'ERRO'
                                  : log.level === 'warn' ? 'AVISO' : 'INFO'}
                              </Badge>
                            </Td>
                            <Td fontSize="xs" fontFamily="mono" whiteSpace="nowrap">{log.event || '—'}</Td>
                            <Td fontSize="xs" whiteSpace="nowrap">{log.email || log.uid || '—'}</Td>
                            <Td fontSize="xs" maxW="200px" noOfLines={2}>{log.device || '—'}</Td>
                            <Td fontSize="xs" maxW="300px" noOfLines={3}
                              title={log.message}>{log.message || '—'}</Td>
                          </Tr>
                        );
                      })}
                    {logsData.filter(l => logsFilter === 'all' || l.level === logsFilter).length === 0 && (
                      <Tr><Td colSpan={6} textAlign="center" py="24px" color="gray.400" fontSize="sm">
                        Nenhum log encontrado.
                      </Td></Tr>
                    )}
                  </Tbody>
                </Table>
              </Box>
            </>
          )}
        </Card>
      ) : null}

      {/* ── Seletor de Empresa para Relatório ─────────────────────────────── */}
      <Modal isOpen={isRelOpen} onClose={onRelClose} size="md" isCentered>
        <ModalOverlay backdropFilter="blur(4px)"/>
        <ModalContent>
          <ModalHeader pb="2">
            <Flex align="center" gap="8px">
              <Icon as={MdPrint} color="green.400"/>
              <Text fontSize="md" fontWeight="700">Selecione o modelo do relatório</Text>
            </Flex>
          </ModalHeader>
          <ModalCloseButton/>
          <ModalBody pb="6">
            <Text fontSize="sm" fontWeight="700" mb="2">Número do contrato:</Text>
            <SimpleGrid columns={2} gap="8px" mb="4">
              {CONTRATOS.map(c => (
                <Box key={c.key}
                  as="button"
                  onClick={() => {
                    setContratoSelecionado(c);
                    setContratoNumeroInput(c.numero || '');
                    setContratoCidadeInput(c.cidade || '');
                  }}
                  border="2px solid"
                  borderColor={contratoSelecionado?.key === c.key ? 'blue.400' : 'gray.200'}
                  borderRadius="8px" p="10px 12px"
                  bg={contratoSelecionado?.key === c.key ? 'blue.50' : 'transparent'}
                  _dark={{ borderColor: contratoSelecionado?.key === c.key ? 'blue.400' : 'gray.600', bg: contratoSelecionado?.key === c.key ? 'blue.900' : 'transparent' }}
                  textAlign="left" cursor="pointer" transition="all .15s" w="100%"
                >
                  <Text fontSize="11px" fontWeight="700"
                    color={contratoSelecionado?.key === c.key ? 'blue.600' : 'gray.700'}
                    _dark={{ color: contratoSelecionado?.key === c.key ? 'blue.200' : 'gray.300' }}>
                    {c.label}
                  </Text>
                  <Text fontSize="10px" color="gray.500">{c.cidade}</Text>
                </Box>
              ))}
            </SimpleGrid>
            <SimpleGrid columns={{ base: 1, md: 2 }} gap="8px" mb="4">
              <Box>
                <Text fontSize="11px" fontWeight="600" mb="1">Contrato (editável)</Text>
                <Input
                  size="sm"
                  value={contratoNumeroInput}
                  onChange={(e) => setContratoNumeroInput(e.target.value)}
                  placeholder="Ex.: 11.529/25"
                />
              </Box>
              <Box>
                <Text fontSize="11px" fontWeight="600" mb="1">Cidade / Local (editável)</Text>
                <Input
                  size="sm"
                  value={contratoCidadeInput}
                  onChange={(e) => setContratoCidadeInput(e.target.value)}
                  placeholder="Ex.: São José dos Campos - SP"
                />
              </Box>
            </SimpleGrid>
            <Text fontSize="sm" color={subText} mb="4">Para qual empresa será gerado este relatório?</Text>
            <SimpleGrid columns={2} gap="12px">
              {[
                { key:'pg',        nome:'PG Soluções', cor:'blue.500',  bg:'blue.50',  dark:'blue.900',  logo: window.location.origin + '/logo.png' },
                { key:'norbrasil', nome:'Norbrasil',   cor:'green.600', bg:'green.50', dark:'green.900', logo: norbrasil_logo },
              ].map(({ key, nome, cor, bg, dark, logo }) => (
                <Box key={key}
                  as="button"
                  onClick={() => {
                    const contratoFinal = {
                      ...(contratoSelecionado || {}),
                      numero: (contratoNumeroInput || '').trim() || (contratoSelecionado?.numero || ''),
                      cidade: (contratoCidadeInput || '').trim() || (contratoSelecionado?.cidade || ''),
                    };
                    onRelClose();
                    if (relatorioOS) imprimirRelatorio(relatorioOS, key, contratoFinal);
                  }}
                  border="2px solid" borderColor="transparent"
                  borderRadius="12px" p="14px"
                  bg={bg} _dark={{ bg: dark }}
                  textAlign="center"
                  cursor="pointer"
                  transition="all .15s"
                  _hover={{ borderColor: cor, transform: 'translateY(-2px)', boxShadow: 'md' }}
                  _active={{ transform: 'scale(.97)' }}
                >
                  <Image
                    src={logo}
                    alt={nome}
                    h="44px" mx="auto" mb="8px" objectFit="contain"
                  />
                  <Text fontSize="12px" fontWeight="700" color={cor}>{nome}</Text>
                </Box>
              ))}
            </SimpleGrid>
            {relatorioOS && (
              (relatorioOS.tipoServico || '').toLowerCase().includes('corante') ||
              (relatorioOS.tipoServico || '').toLowerCase().includes('ramal')
            ) && (
              <>
                <Divider my="3"/>
                <Text fontSize="11px" color="gray.500" textAlign="center" mb="2">Formato oficial SABESP</Text>
                <Box
                  as="button"
                  w="100%"
                  onClick={() => {
                    const contratoFinal = {
                      ...(contratoSelecionado || {}),
                      numero: (contratoNumeroInput || '').trim() || (contratoSelecionado?.numero || ''),
                      cidade: (contratoCidadeInput || '').trim() || (contratoSelecionado?.cidade || ''),
                    };
                    onRelClose();
                    if (relatorioOS) imprimirRelatorio(relatorioOS, 'sabesp', contratoFinal);
                  }}
                  border="2px solid" borderColor="transparent"
                  borderRadius="12px" p="12px"
                  bg="#eaf0fb" _dark={{ bg: 'blue.900' }}
                  textAlign="center"
                  cursor="pointer"
                  transition="all .15s"
                  _hover={{ borderColor: '#1a3a6e', transform: 'translateY(-2px)', boxShadow: 'md' }}
                  _active={{ transform: 'scale(.97)' }}
                >
                  <Image src={sabesp_logo} alt="SABESP" h="38px" mx="auto" mb="6px" objectFit="contain"/>
                  <Text fontSize="13px" fontWeight="800" color="#1a3a6e" letterSpacing="0.04em">
                    📋 Relatório Formato SABESP
                  </Text>
                  <Text fontSize="10px" color="#2d4a7a" mt="1">
                    Inspeção Predial — Teste de Corante
                  </Text>
                </Box>
              </>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>

      {/* ── Confirmação de Exclusão ────────────────────────────────────────── */}
      <AlertDialog
        isOpen={isDeleteOpen}
        leastDestructiveRef={deleteRef}
        onClose={onDeleteClose}
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent mx="16px">
            <AlertDialogHeader fontSize="md" fontWeight="700">
              Apagar Ordem de Serviço
            </AlertDialogHeader>
            <AlertDialogBody>
              <Text fontSize="sm">
                Tem certeza que deseja apagar a OS{' '}
                <Text as="span" fontWeight="700">
                  {deleteTarget?.numeroOS || deleteTarget?.id}
                </Text>
                {deleteTarget?.logradouro ? ` — ${deleteTarget.logradouro}` : ''}?
              </Text>
              <Text fontSize="xs" color="red.500" mt="8px">
                Esta ação é permanente e não pode ser desfeita.
              </Text>
            </AlertDialogBody>
            <AlertDialogFooter gap="8px">
              <Button ref={deleteRef} size="sm" onClick={onDeleteClose} isDisabled={deleting}>
                Cancelar
              </Button>
              <Button colorScheme="red" size="sm" isLoading={deleting} onClick={confirmarExclusao}>
                Apagar
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

    </Box>
  );
}
